import React, { useEffect } from "react";
import {Button, Form, InputNumber, Tooltip} from "antd";
import { SettingInterface } from "src/store/community/settingsSlice";

import '../Settings.scss';
import { DollarOutlined, QuestionCircleOutlined } from "@ant-design/icons";

interface propsInterface {
  onFinish: Function;
  params?: SettingInterface['data'] | undefined;
}

const _Rewards = ({ onFinish, params }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const DailyInputs = () => {
    if (!params?.daily_rewards) {
      return null;
    }

    return (
      <>
        {
          Object.keys(params.daily_rewards).map((key: string) => (
            <Form.Item
              key={key}
              name={['daily_rewards', key]}
              rules={[{ required: true, message: 'Missing value' }]}
            >
              <InputNumber
                addonBefore={key}
                min={0}
                placeholder='5'
                prefix={<DollarOutlined />}
              />
            </Form.Item>
          ))
        }
      </>
    )
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      className='v-form v-settings-form'
      layout="vertical"
      autoComplete="off"
      initialValues={params}
    >
      <h6 className="v-content-label o-sm">
        Rewarded

        <Tooltip title="Watch video coins reward">
          <QuestionCircleOutlined />
        </Tooltip>
      </h6>

      <Form.Item
        name={['rewarded', 'coins']}
        rules={[{ required: true, message: 'Missing value' }]}
        className='v-mb-30'
      >
        <InputNumber
          addonBefore='rewarded'
          min={0}
          placeholder='5'
          prefix={<DollarOutlined />}
        />
      </Form.Item>

      <h6 className="v-content-label o-sm">Daily Rewards</h6>

      <DailyInputs />

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Apply
        </Button>
      </Form.Item>
    </Form>
  );
}

export default _Rewards;
